module.exports = __webpack_public_path__ + "img/gyrosicon_selected.62c6c8ed.png";